import styled from "styled-components";

import Calendar from "react-calendar";

const CustomCalendar = styled(Calendar)`
  &.react-calendar {
    width: 100%;
    border: none;
    font-family: "regular";
  }

  .react-calendar__tile--now {
    background: white;
  }

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #e6e6e6;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: #22202d50 !important;
  }

  .react-calendar__month-view__days__day {
    color: #22202d;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #22202d;
  }

  .react-calendar__tile--active {
    background: #442ed0;
    color: white;
    border-radius: 50%;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #442ed0;
  }

  .react-calendar__tile:disabled {
    color: #22202d10 !important;
    cursor: not-allowed;
    background: #ffffff;
  }
`;

export default CustomCalendar;
